export const WORKOUT_PRIVATE_ACCESS_ROUTE = "/workout_plan/access";
export const WORKOUT_PRIVATE_ACCESS_PENDING_TOKEN_KEY =
  "workoutPlan.pendingPrivateAccessToken";

export const WORKOUT_PRIVATE_ACCESS_FUNCTION_REGION = "us-central1";
export const WORKOUT_PRIVATE_ACCESS_FUNCTION_NAME =
  "exchangeWorkoutPrivateAccess";

export const WORKOUT_ACCESS_VERSION = 1;
export const WORKOUT_ROLES = {
  PARTICIPANT: "participant",
  PLANNER: "planner",
};
